import React from 'react';
import { Layout, Row, Col, Space } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TOOLS } from '../../pages/portal/tools/toolsRegistry';

const { Footer } = Layout;

const PortalFooter: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Footer className="portal-footer">
      <div style={{ maxWidth: 'var(--portal-max-width)', margin: '0 auto' }}>
        <Row gutter={[48, 40]}>
          {/* Brand */}
          <Col xs={24} sm={12} md={6}>
            <div style={{ marginBottom: 16 }}>
              <span style={{ fontSize: 22, fontWeight: 700, color: '#fff', letterSpacing: '-0.03em' }}>
                Pitto
              </span>
              <span style={{
                fontSize: 10,
                fontFamily: 'var(--portal-font-mono)',
                color: 'var(--portal-accent)',
                marginLeft: 8,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
              }}>
                AI
              </span>
            </div>
            <p style={{ color: 'var(--portal-text-muted)', fontSize: 14, lineHeight: 1.7, margin: 0, maxWidth: 280 }}>
              {t('portal.footer.companyDescription')}
            </p>
          </Col>

          {/* Product */}
          <Col xs={12} sm={12} md={4}>
            <h4 className="footer-title">{t('portal.footer.quickLinks')}</h4>
            <Space direction="vertical" size={0}>
              <Link to="/features" className="footer-link">{t('portal.nav.features')}</Link>
              <Link to="/pricing" className="footer-link">{t('portal.nav.pricing')}</Link>
              <Link to="/try" className="footer-link">{t('trial.heroTitle', 'Try Pitto')}</Link>
            </Space>
          </Col>

          {/* Resources */}
          <Col xs={12} sm={12} md={4}>
            <h4 className="footer-title">Resources</h4>
            <Space direction="vertical" size={0}>
              <Link to="/tools" className="footer-link">{t('portal.tools.footerLink', '無料ツール')}</Link>
              <Link to="/compare/overseas-ai-chatbot" className="footer-link">{t('portal.compare.footerLink', '他方式との比較')}</Link>
              <Link to="/mcp" className="footer-link">{t('portal.nav.mcp', 'MCP')}</Link>
              <Link to="/news" className="footer-link">{t('portal.nav.news', 'News')}</Link>
              <Link to="/contact" className="footer-link">{t('portal.nav.contact')}</Link>
              <Link to="/playground" className="footer-link">{t('playground.title', 'Playground')}</Link>
            </Space>
          </Col>

          {/* Free tools — every tool listed so the whole set is reachable (and
              crawlable) from any page, not just via the /tools index. */}
          <Col xs={24} sm={12} md={5}>
            <h4 className="footer-title">{t('portal.tools.footerLink', '無料ツール')}</h4>
            <div>
              {TOOLS.map((tool) => (
                <Link key={tool.path} to={tool.path} className="footer-link">
                  {t(`portal.tools.${tool.key}CardTitle`)}
                </Link>
              ))}
            </div>
          </Col>

          {/* Legal */}
          <Col xs={12} sm={12} md={5}>
            <h4 className="footer-title">{t('portal.footer.legal')}</h4>
            <Space direction="vertical" size={0}>
              <Link to="/privacy" className="footer-link">{t('portal.footer.privacy')}</Link>
              <Link to="/terms" className="footer-link">{t('portal.footer.terms')}</Link>
              <Link to="/cookies" className="footer-link">{t('portal.footer.cookies', 'Cookie Policy')}</Link>
              <Link to="/dpa" className="footer-link">{t('portal.footer.dpa', 'Data Processing Agreement')}</Link>
              <Link to="/aup" className="footer-link">{t('portal.footer.aup', 'Acceptable Use Policy')}</Link>
              <Link to="/tokushoho" className="footer-link">{t('portal.footer.tokushoho', '特定商取引法に基づく表記')}</Link>
            </Space>
          </Col>
        </Row>

        <div style={{
          borderTop: '1px solid var(--portal-border)',
          marginTop: 48,
          paddingTop: 24,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 16,
        }}>
          <span style={{ color: 'var(--portal-text-muted)', fontSize: 13, fontFamily: 'var(--portal-font-mono)' }}>
            © {currentYear}{' '}
            <a
              href="https://www.kawazu-sakura-software.co.jp"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              河津桜ソフト（株） / KAWAZUZAKURA SOFT K.K.
            </a>
          </span>
        </div>
      </div>
    </Footer>
  );
};

export default PortalFooter;
